module.exports = __webpack_public_path__ + "static/img/themeLogo.cde3ee0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUS/themeLogo.png
// module id = Pl+I
// module chunks = 7